import { useState } from "react";
import { Copy, Check } from "lucide-react";

interface CopyButtonProps {
  text: string;
  label?: string;
  className?: string;
}

export default function CopyButton({ text, label, className }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch { /* clipboard access denied — silent fail */ }
  };
  return (
    <button
      onClick={copy}
      aria-label={`Copy ${label || text}`}
      className={
        className ??
        "flex items-center gap-2 text-xs font-mono bg-muted/50 rounded px-3 py-2 w-full text-left hover:bg-muted transition-colors group"
      }
    >
      {copied ? (
        <Check size={12} className="text-primary shrink-0" />
      ) : (
        <Copy size={12} className="text-muted-foreground shrink-0 group-hover:text-foreground" />
      )}
      <span className="truncate flex-1">{label || text}</span>
    </button>
  );
}
